import React from 'react';
import { TINT_RANGE } from '../data/constants';

export default function TiltTint({ drag }) {
  const x = drag.x;
  if (Math.abs(x) < 8) return null;
  const opacity = Math.min(TINT_RANGE, Math.abs(x) / 480);
  const color = x < 0 ? '239, 126, 70' : '76, 235, 159';
  const direction = x < 0 ? '90deg' : '270deg';
  return (
    <div
      className="tilttint"
      style={{
        background: `linear-gradient(${direction}, rgba(${color}, ${opacity}) 0%, rgba(${color}, 0) 60%)`,
      }}
    />
  );
}
